import logo from './logo.svg';
import './App.css';
import SalaryList from './salary';
function App() {
  return (
    <div style={{ padding: 20 }}>
      <SalaryList />
    </div>
  );
}

export default App;
